// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccountInfoCard_ai__27Lvn {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 3rem 5rem 3rem 5rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  height: auto;
  gap: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
}
@media only screen and (max-width: 56.25em) {
  .AccountInfoCard_ai__27Lvn {
    height: auto;
    padding: 3rem;
  }
}
.AccountInfoCard_ai__line__AwVhT {
  border-top: 1px solid var(--color-grey-2);
}
.AccountInfoCard_ai__copy__9puFA {
  display: flex;
  font-size: 3rem;
  color: var(--color-white);
  cursor: pointer;
  background-color: var(--color-dark);
  padding: 1rem 2rem;
  border-radius: 0.5rem;
  align-items: center;
}
.AccountInfoCard_ai__copy__9puFA > :not(:last-child) {
  margin-right: 2rem;
}
.AccountInfoCard_ai__bank__zb44D {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 2rem;
  border-radius: 1rem;
  background-color: var(--color-primary-3);
  gap: 1rem;
}
@media only screen and (max-width: 56.25em) {
  .AccountInfoCard_ai__bank__zb44D {
    height: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Wallet/AccountInfoCard.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,mBAAA;EACA,oCAAA;EACA,YAAA;EACA,SAAA;EACA,4CAAA;AADD;AAGC;EAXD;IAYE,YAAA;IACA,aAAA;EAAA;AACF;AAEC;EACC,yCAAA;AAAF;AAGC;EACC,aAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,mCAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AADF;AAIE;EACC,kBAAA;AAFH;AAMC;EACC,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,SAAA;AAJF;AAME;EATD;IAUE,YAAA;EAHD;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.ai {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbox-sizing: border-box;\n\tpadding: 3rem 5rem 3rem 5rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-white);\n\theight: auto;\n\tgap: 2rem;\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\n\t@media only screen and (max-width: $bp-900) {\n\t\theight: auto;\n\t\tpadding: 3rem;\n\t}\n\n\t&__line {\n\t\tborder-top: 1px solid var(--color-grey-2);\n\t}\n\n\t&__copy {\n\t\tdisplay: flex;\n\t\tfont-size: 3rem;\n\t\tcolor: var(--color-white);\n\t\tcursor: pointer;\n\t\tbackground-color: var(--color-dark);\n\t\tpadding: 1rem 2rem;\n\t\tborder-radius: .5rem;\n\t\talign-items: center;\n\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 2rem;\n\t\t}\n\t}\n\n\t&__bank {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tbox-sizing: border-box;\n\t\tpadding: 2rem;\n\t\tborder-radius: 1rem;\n\t\tbackground-color: var(--color-primary-3);\n\t\tgap: 1rem;\n\n\t\t@media only screen and (max-width: $bp-900) {\n\t\t\theight: auto;\n\t\t}\n\t}\n\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ai": `AccountInfoCard_ai__27Lvn`,
	"ai__line": `AccountInfoCard_ai__line__AwVhT`,
	"ai__copy": `AccountInfoCard_ai__copy__9puFA`,
	"ai__bank": `AccountInfoCard_ai__bank__zb44D`
};
export default ___CSS_LOADER_EXPORT___;
